/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Custompages1Inputs */

const en_nav_custompages1 = /** @type {(inputs: Nav_Custompages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Pages`)
};

const de_nav_custompages1 = /** @type {(inputs: Nav_Custompages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "Custom Pages" |
*
* @param {Nav_Custompages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_custompages1 = /** @type {((inputs?: Nav_Custompages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Custompages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_custompages1(inputs)
	return de_nav_custompages1(inputs)
});
export { nav_custompages1 as "nav_customPages" }